document.addEventListener("DOMContentLoaded", function () {
    let subscriptionCardProducts = document.querySelectorAll(".subscription-card__products");
  
    subscriptionCardProducts.forEach(subscriptionCardProduct => {
      let subscriptionCardProductList = subscriptionCardProduct.querySelectorAll(".subscription-card__product");
      let numberOfProducts = subscriptionCardProductList.length;
      if (numberOfProducts <= 3) return;
      
      let numberOfProductsToShow = numberOfProducts === 5 ? 3 : 3;
      let hiddenProducts = Array.from(subscriptionCardProductList).slice(numberOfProductsToShow);
      let plural = 's';
      if (hiddenProducts.length === 1) {
        plural = '';
      }
      hiddenProducts.forEach((product) => product.style.display = "none");
      
      let showMoreLink = document.createElement("li");
      showMoreLink.classList.add("subscription-card__product", "subscription-card__product--link");
      showMoreLink.innerHTML = `<a class="js-show-more">Plus ${hiddenProducts.length} product${plural}</a>`;
      subscriptionCardProduct.appendChild(showMoreLink);
      
      showMoreLink.addEventListener("click", function (e) {
        e.preventDefault();
        if (!showMoreLink.classList.contains("is-active")) {
            hiddenProducts.forEach((product) => product.style.display = "list-item");
            showMoreLink.classList.add("is-active");
            showMoreLink.querySelector('a').textContent = "Show less";
        } else {
            hiddenProducts.forEach((product) => product.style.display = "none");
            showMoreLink.classList.remove("is-active");
            showMoreLink.querySelector('a').textContent = `Plus ${hiddenProducts.length} product${plural}`;
        }
      });      
    });
  });
  
  